import React from "react"
import VacancyAlert from './VacancyAlert'
import TermDates2026 from "./TermDates2026"
const Termdates = () => {
  return (
    <div className='col s12 homeWrapper'>
     <VacancyAlert />
     <TermDates2026 />
    </div>
  )
}
export default Termdates
